import React from 'react';
import StatusCard from '../../../../../Common/DesignSystem/StatusCard';
import { Heading6 } from '../../../../../Common/DesignSystem/Text';
import Button from '../../../../../Common/DesignSystem/Button';
import colours from '../../../../../Common/DesignSystem/Colours';

export const VehicleStatusCard = ({ vehicle, setTab, latestReport, vehicle_usage_types, rr_vehicle, legacyApiVehicleData, match, history, closeModal }) => {
    const bookVehicle = () => {
        history.push('/bookings/new/' + match.params.v_id)
    }

    const retireVehicle = () => {
        history.push(match.url + '/retire/' + match.params.v_id)
    }

	return (
		<div className="overlay_header_bordered">
			<div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'flex-start'}}>
				<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
					<Heading6 style={{color: colours.primary.grey01}}>Status</Heading6>
					{vehicle.active && vehicle.status !== 'retired' && (
						<Button tertiary small color={colours.primary.grey02} label="Retire Vehicle" leading_ic="RetireDate" onClick={retireVehicle} />
					)}
				</div>
				<div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'flex-start'}}>
					<div style={{marginTop: 12}}>
						<StatusCard type="vehicle" vehicle={vehicle} history={history} match={match} closeModal={closeModal} usageTypes={vehicle_usage_types}/>
						<div style={{marginTop: 16}}></div>
						{latestReport && (
							<StatusCard type="damage" variant={rr_vehicle ? "rr-nodamage" : "nodamage"} history={history} match={match} closeModal={closeModal} vehicle_details={legacyApiVehicleData} setTab={setTab} latestReport={latestReport} />
						)}
					</div>
					<div style={{flex: 1, display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', marginTop: 16}}>
						<Button secondary label="Book" leading_ic="Calendar" onClick={bookVehicle}/>
					</div>
				</div>
			</div>
		</div>
	)
}